<template>
  <div id="ErrorSigningDoc" aria-hidden="true" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 p-0">
          <h5 id class="modal-title font32 text-capitalize pl-5 pt-5 font-weight-bold">
            Waiver confirmation
          </h5>
        </div>
        <hr />
        <div class="modal-body p-5">
          <p class="font27 pb-4">
            Participants must sign the waiver to proceed. Click here to go back to the previous
            screen.
          </p>
          <hr class="mt-5" />
          <button class="border-layout btn-cancel p-3 mx-4" @click="cancelWaiver()">Cancel</button>
          <CustomButton :buttonText="'Sign waiver'" @click.native="onButtonClick(true)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import CustomButton from '../components/Button.vue';
import { API } from '@/utils/amplifyCompat';
import { Modal } from 'bootstrap';
import { useLegacyRouter, useLegacyStore } from '@/composables/useLegacyGlobals';

export default defineComponent({
  name: 'ErrorSigningDoc',
  components: {
    CustomButton,
  },
  setup() {
    const store = useLegacyStore();
    const router = useLegacyRouter();

    const onButtonClick = async (combined) => {
      store.state.loader = true;
      const urlData = {
        body: {
          return_url: window.location.origin + window.location.pathname,
          combined,
        },
      };
      const res = await API.post(
        'proxy',
        `/${store.state.selected_site_id}/waiver/prepare`,
        urlData
      );
      store.commit('setEnvelopeId', res.envelopeId);
      window.location.href = res.redirectUrl;
    };

    const cancelWaiver = () => {
      router.push({ path: '/portal' });
      const modalEl = document.getElementById('ErrorSigningDoc');
      if (modalEl) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.hide();
      }
    };

    return {
      onButtonClick,
      cancelWaiver,
    };
  },
});
</script>

<style scoped>
hr {
  border-top: 1px solid #ffc627;
}
.btn-cancel {
  border-radius: 30px;
  min-width: 120px;
}
</style>
